import { node } from "~/util/dom";
import { IRouteTypeSubitemItem } from "../const";

export default class ParamsItemSelectItemCar {
	_container: HTMLLIElement;

	constructor(item: IRouteTypeSubitemItem) {
		this._container = node("li", { innerHTML: `<p class="title">${item.label}</p><p class="desc">${item.desc}</p>`, className: item.beta ? "beta" : "" });
	}

	// eslint-disable-next-line class-methods-use-this
	destroy() {
	}

	get container() {
		return this._container;
	}

	set selected(selected: boolean) {
		this._container.classList[selected ? "add" : "remove"]("selected");
	}
}
